
import { defineComponent } from "vue";
import ResetPassword from "@/components/account/ResetPassword.vue";

export default defineComponent({
  name: "ResetPasswordView",
  components: {
    ResetPassword,
  },
});
